// This function allow to reference chunks
__webpack_require__.miniCssF = function(chunkId) {
  // return url for filenames not based on template
  if (chunkId === 7888) return "css/design_system-5527a96b70d91a12.css";
if (chunkId === 1710) return "css/1710-0573bf035ed5dce9.css";
  // return url for filenames based on template
  return "css/" + chunkId + "-" + {1718: "25e43d52410aceac",2429: "fb6768e074e958b7",3641: "91ecc8e70b90fc55",370: "a8d311b114ec77ce",424: "25e43d52410aceac",4278: "5e7c04a2b0740134",7345: "096c246142ab87bd",9468: "fff606c4f8ef08bd",9590: "25e43d52410aceac",9666: "b042f72b365d28e9",}[chunkId] + ".css"
}